"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const react_router_dom_1 = require("react-router-dom");
const utilities_1 = require("../utilities");
const NavBar_1 = __importDefault(require("./modules/NavBar"));
const Login_1 = __importDefault(require("./modules/Login"));
const NotFound_1 = __importDefault(require("./pages/NotFound"));
const YourPosts_1 = __importDefault(require("./pages/YourPosts"));
const Resources_1 = __importDefault(require("./pages/Resources"));
const About_1 = __importDefault(require("./pages/About"));
const client_socket_1 = require("../client-socket");
require("../utilities.css");
require("./App.css");
const colors_1 = require("@mui/material/colors");
// import { GOOGLE_CLIENT_ID } from "../../../shared/constants";
const blue_logo_png_1 = __importDefault(require("../public/blue_logo.png"));
const yellow_logo_png_1 = __importDefault(require("../public/yellow_logo.png"));
const styles_1 = require("@mui/material/styles");
const material_1 = require("@mui/material");
const FoodPage_1 = __importDefault(require("./pages/FoodPage"));
const NewFood_1 = __importDefault(require("./pages/NewFood"));
const App = () => {
    const [userId, setUserId] = (0, react_1.useState)(undefined);
    console.log("Welcome to App");
    (0, react_1.useEffect)(() => {
        (0, utilities_1.get)("/api/whoami")
            .then((user) => {
            console.log("Just called whoami");
            if (user._id) {
                console.log("whoami returned a user", user);
                // They are registed in the database and currently logged in.
                setUserId(user.userId);
            }
        })
            .then(() => client_socket_1.socket.on("connect", () => {
            (0, utilities_1.post)("/api/initsocket", { socketid: client_socket_1.socket.id });
        }));
    }, []);
    // Handle notifications
    (0, react_1.useEffect)(() => {
        if (userId) {
            Notification.requestPermission().then((result) => {
                // TODO: show something if notifications are off
                console.log("We requested notifications permission, got", result);
            });
            const onNewFoodEvent = (foodEvent) => {
                var _a;
                console.log("NewFoodEvent fired!", foodEvent);
                const notification = new Notification((_a = foodEvent.title) !== null && _a !== void 0 ? _a : `${foodEvent.food_type} in ${foodEvent.location}`, {
                    body: foodEvent.content,
                    icon: "/favicon.png",
                });
            };
            client_socket_1.socket.on("NewFoodEvent", onNewFoodEvent);
            return () => {
                client_socket_1.socket.off("NewFoodEvent", onNewFoodEvent);
            };
        }
    }, [userId]);
    const handleLogin = (credentialResponse) => {
        console.log("On handle login, got", credentialResponse);
        const userToken = credentialResponse.credential;
        console.log("userToken is", userToken);
        const decodedCredential = (0, jwt_decode_1.default)(userToken);
        console.log("decodedCredential is", decodedCredential);
        console.log(`Logged in as ${decodedCredential.name}`);
        (0, utilities_1.post)("/api/login/google", { token: userToken }).then((user) => {
            setUserId(user.userId);
            (0, utilities_1.post)("/api/initsocket", { socketid: client_socket_1.socket.id });
        });
    };
    const handleLogout = () => {
        setUserId(undefined);
        (0, utilities_1.post)("/api/logout");
    };
    // https://medium.com/hypersphere-codes/detecting-system-theme-in-javascript-css-react-f6b961916d48
    // read device theme (only once, since the main reason is that I want to minimize people on dark theme getting light flashes,
    // as opposed to a third setting to use the device setting - which would be more of a stretch goal and would need more
    // than a simple switch in the UI)
    const deviceTheme = window.matchMedia("(prefers-color-scheme: dark)") ? "dark" : "light";
    const [mode, setMode] = (0, react_1.useState)(deviceTheme);
    // load theme from local storage if available
    (0, react_1.useEffect)(() => {
        const theme = localStorage.getItem("theme");
        if (theme) {
            setMode(theme);
        }
    }, []);
    // persist theme changes in local storage
    (0, react_1.useEffect)(() => {
        localStorage.setItem("theme", mode);
    }, [mode]);
    const lightTheme = (0, styles_1.createTheme)({
        palette: {
            mode: "light",
            info: { main: "rgb(49, 58, 83)", },
            primary: {
                main: "#f4575b",
                contrastText: "#fff",
            },
            secondary: {
                main: "#001e3c",
                contrastText: "#fff",
            },
            error: {
                main: colors_1.red[700],
            },
        },
        typography: {
            fontFamily: "Montserrat, Roboto, -apple-system, Segoe UI, sans-serif",
        },
    });
    const darkTheme = (0, styles_1.createTheme)({
        palette: {
            mode: "dark",
            info: { main: "#fff", },
            primary: {
                main: "#f4575b",
                light: "#f4575b",
                dark: "#f4575b",
                contrastText: "#003c77",
            },
            secondary: {
                main: "#fdb73e",
                light: "#fdb73e",
                dark: "#fdb73e",
                contrastText: "#001e3c",
            },
            error: {
                main: colors_1.deepOrange.A400,
            },
        },
        typography: {
            fontFamily: "Montserrat, Roboto, -apple-system, Segoe UI, sans-serif",
        },
    });
    const selectedTheme = mode === "dark" ? darkTheme : lightTheme;
    const selectedLogo = mode === "dark" ? yellow_logo_png_1.default : blue_logo_png_1.default;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.ThemeProvider, { theme: selectedTheme },
            react_1.default.createElement(material_1.CssBaseline, null),
            react_1.default.createElement(react_router_dom_1.BrowserRouter, null, userId ? (react_1.default.createElement(utilities_1.UserIdContext.Provider, { value: userId },
                react_1.default.createElement(NavBar_1.default, { themeMode: mode, setThemeMode: setMode, logo: selectedLogo, handleLogout: handleLogout }),
                react_1.default.createElement(react_router_dom_1.Routes, null,
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "/food/latest", replace: true }) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/food", element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "/food/latest", replace: true }) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/food/latest", element: react_1.default.createElement(FoodPage_1.default, { time: "latest", view: "grid" }) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/food/scheduled", element: react_1.default.createElement(FoodPage_1.default, { time: "scheduled", view: "grid" }) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/food/calendar", element: react_1.default.createElement(FoodPage_1.default, { time: "scheduled", view: "calendar" }) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/food/new", element: react_1.default.createElement(NewFood_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/about", element: react_1.default.createElement(About_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/resources", element: react_1.default.createElement(Resources_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/yourposts", element: react_1.default.createElement(YourPosts_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "*", element: react_1.default.createElement(NotFound_1.default, null) })))) : (react_1.default.createElement(Login_1.default, { handleLogin: handleLogin, handleLogout: handleLogout, userId: userId }))))));
};
exports.default = App;
